import { render, staticRenderFns } from "./uploadBanchExcel.vue?vue&type=template&id=c40c8766"
import script from "./uploadBanchExcel.vue?vue&type=script&lang=js"
export * from "./uploadBanchExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports